import React from "react";
import Footer from "../../components/Footer";
import Company from "./CompanyView";

export function CompanyContainer() {
  return (
    <div>
      <Company title="Contact"/>
      <Footer/>
    </div>
  );
}
